module.exports = __webpack_public_path__ + "static/media/JUSTSans-Bold.046253a6.woff";